export default __webpack_public_path__ + "static/media/dev_2.eedb5b65.png";